// extracted by mini-css-extract-plugin
module.exports = {"services":"services-module--services--nd0Sa"};